// Node Modules
import moment from 'moment';

// 日付をフォーマットして返す
const dateFormat = (date, format) => {
    const m = moment(date);
    return m.format(format);
};

export default dateFormat